import React, { ChangeEvent } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { InputProps } from '../../types';

import { useQv3Context } from 'src/QuestionnairesV3/hooks';
import SampleAnswer from 'src/QuestionnairesV3/components/SampleAnswer';

export default function SimpleTextField(props: Readonly<InputProps>) {
  const { error, value, onChange, fieldId } = props;
  const { options, queries } = useQv3Context();
  const field = queries.fields._dataMap[fieldId];
  const hints = options?.hints?.[field.id];
  return (
    <>
      <Autocomplete
        freeSolo
        options={hints || []}
        value={value ?? ''}
        onChange={(event, value) => onChange?.(value, event as ChangeEvent)}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            multiline
            label={field.label}
            onChange={(e) => onChange?.(e.target.value, e)}
            error={!!error}
            helperText={error}
            // disabled={disabled}
            sx={{
              // mb: field.placeholder ? '12px' : '32px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: value ? 'background.default' : 'inherit',
              },
            }}
          />
        )}
      />
      <SampleAnswer placeholder={field.placeholder} />
    </>
  );
}
